
const stringHelper = {
    ///音标包装
    symbolWrapper: function (symbol) {
        if (symbol == "") {
            return ""
        }
        if (symbol.indexOf("/") == 0) {
            return symbol
        }
        return `/${symbol}/`
    },
    ///获取数字
    getNumber: function (input) {
        var res = input.replace(/\D/g, "");
        if (res.length == 0) {
            return 0
        }
        return parseInt(res)
    },
    ///获取单词
    getWord: function (input) {
        input = input.trim();

        // 正则说明：
        // ^              开头
        // [a-zA-Z]+      1个或多个字母
        // (?:'[a-zA-Z]+)*   0个或多个 ' + 字母序列（撇号夹在字母中间）
        // $              结尾
        //
        // 先用 match 全局匹配所有符合这个形式的单词，再取第一个
        // 如果想从字符串中找到第一个符合的单词，直接用 match 即可

        const regex = /[a-zA-Z]+(?:'[a-zA-Z]+)*/g;
        const matches = input.match(regex);
        return matches ? matches[0] : "";
    }
}

export default stringHelper